import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const MoreHorizontalIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue5d3'}</MuiIcon>
        );
    })
